export const getDrawLineStyle = (laneIndex, activeLaneIndex, spacing) => {
  const heightStep = Math.pow(2, laneIndex - activeLaneIndex)
  const topStep = Math.pow(2, laneIndex - 1 - activeLaneIndex) - 1

  return {
    top: `calc(-6px - ${topStep * spacing}px)`,
    height: `${heightStep * spacing + 2}px`
  }
}

export const calculateDrawCardMarginStep = (laneIndex, activeLaneIndex) => {
  if (laneIndex < activeLaneIndex) {
    return 0
  }

  return Math.pow(2, laneIndex - activeLaneIndex) - 1
}
